import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { leaderboardAPI } from '@/lib/api';
import { Sparkles, ArrowLeft, Trophy, Medal } from 'lucide-react';

const Leaderboard = () => {
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);

  useEffect(() => {
    loadLeaderboard();
  }, []);

  const loadLeaderboard = async () => {
    try {
      const data = await leaderboardAPI.get(10);
      setUsers(data.leaderboard || []);
    } catch (error) {
      console.error('Load error:', error);
    }
  };

  const getRankIcon = (index) => {
    if (index === 0) return <Trophy className="h-8 w-8 text-yellow-500" />;
    if (index === 1) return <Medal className="h-8 w-8 text-gray-400" />;
    if (index === 2) return <Medal className="h-8 w-8 text-orange-600" />;
    return <span className="text-2xl font-bold text-gray-600">#{index + 1}</span>;
  };

  return (
    <div className="min-h-screen">
      <nav className="px-6 py-4 bg-white/95 backdrop-blur-sm border-b border-border shadow-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto flex items-center gap-4">
          <Button variant="ghost" size="sm" onClick={() => navigate('/dashboard')}>
            <ArrowLeft className="h-5 w-5" />
          </Button>
          <Sparkles className="h-7 w-7 text-primary" />
          <h1 className="text-xl font-semibold text-foreground">Leaderboard</h1>
        </div>
      </nav>

      <div className="max-w-4xl mx-auto px-6 py-12">
        <h2 className="text-4xl md:text-5xl font-bold mb-3 text-center text-foreground">Top <span className="text-primary">Prompt Crafters</span></h2>
        <p className="text-lg text-center mb-12 text-muted-foreground">See who's mastering the art of prompts</p>

        <div className="space-y-3">
          {users.map((user, index) => (
            <Card 
              key={user.user_id} 
              className={`p-6 bg-white border border-border card-shadow-lg hover:shadow-xl transition-all ${index < 3 ? 'bg-gradient-to-r from-primary/5 to-white border-primary/30' : ''}`}
            >
              <div className="flex items-center gap-6">
                <div className="flex-shrink-0 w-16 text-center">
                  {getRankIcon(index)}
                </div>
                <img 
                  src={user.picture || 'https://api.dicebear.com/7.x/avataaars/svg?seed=' + user.user_id} 
                  alt={user.name}
                  className="w-14 h-14 rounded-full border-2 border-border"
                />
                <div className="flex-1">
                  <h3 className="text-lg font-semibold text-foreground">{user.name}</h3>
                  <div className="flex gap-3 text-sm text-muted-foreground">
                    <span>Level {user.level}</span>
                    <span>•</span>
                    <span>{user.badges?.length || 0} badges</span>
                  </div>
                </div>
                <div className="text-right">
                  <div className="text-3xl font-bold text-primary">{user.points}</div>
                  <div className="text-sm text-muted-foreground">points</div>
                </div>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Leaderboard;
